/** Modalidad de entrega comprador desde el partner (checkout v2). */
export const BUYER_PARTNER_DELIVERY_MODES = {
  pickup_at_partner: {
    value: 'pickup_at_partner',
    label: 'Recoger en el local',
    desc: 'Recoges el disco en el partner DreamVinyl elegido.',
  },
  ship_to_buyer: {
    value: 'ship_to_buyer',
    label: 'Envío a mi dirección',
    desc: 'El partner te envía el paquete (si ofrece envío al comprador).',
  },
};

export const SELLER_DROPOFF_STATUSES = {
  pending: 'Pendiente de envío',
  shipped: 'Enviado al partner',
  received: 'Recibido por el partner',
  cancelled: 'Cancelado',
};

export const TRANSACTION_MESSAGE_KINDS = ['text', 'status', 'tracking', 'system'];

export function emptyBuyerShippingAddress() {
  return {
    line1: '',
    line2: '',
    city: '',
    postal_code: '',
    province: '',
    country: 'España',
  };
}

/** @param {Record<string, unknown>|null|undefined} addr */
export function isBuyerShippingAddressComplete(addr) {
  if (!addr || typeof addr !== 'object') return false;
  return !!(
    String(addr.line1 ?? '').trim() &&
    String(addr.city ?? '').trim() &&
    String(addr.postal_code ?? '').trim()
  );
}

/** Snapshot JSON para RPC / sesión Stripe. */
export function buyerShippingAddressSnapshot(addr) {
  const a = addr && typeof addr === 'object' ? addr : {};
  return {
    line1: String(a.line1 ?? '').trim(),
    line2: String(a.line2 ?? '').trim() || null,
    city: String(a.city ?? '').trim(),
    postal_code: String(a.postal_code ?? '').trim(),
    province: String(a.province ?? '').trim() || null,
    country: String(a.country ?? 'España').trim() || 'España',
  };
}

/** Fila devuelta por list_*_for_checkout con flags buyer_* */
export function partnerRowSupportsBuyerMode(row, mode) {
  if (!row) return false;
  if (mode === 'pickup_at_partner') return row.buyer_pickup_available !== false;
  if (mode === 'ship_to_buyer') return row.buyer_ship_available === true;
  return false;
}

export function buyerDeliveryModeLabel(mode) {
  const key = String(mode || '').trim();
  return BUYER_PARTNER_DELIVERY_MODES[key]?.label ?? (key || '—');
}

export function formatShippingAddressOneLine(addr) {
  const a = buyerShippingAddressSnapshot(addr);
  if (!a.line1) return null;
  return [a.line1, a.line2, [a.postal_code, a.city].filter(Boolean).join(' '), a.province, a.country]
    .filter(Boolean)
    .join(', ');
}

/** Campos logística v2 en consultas Supabase */
export const TRANSACTION_LOGISTICS_SELECT =
  'id,listing_id,buyer_id,seller_id,amount,status,created_at,buyer_confirmed_at,tracking_number,shipping_type,shipping_cost,commission,verifier_partner_id,pickup_partner_id,seller_to_partner_mode,buyer_partner_delivery_mode,buyer_shipping_address,seller_dropoff_tracking,seller_dropoff_status,seller_dropoff_shipped_at';

export function isPartnerHubTransaction(t) {
  const s = String(t?.shipping_type || '').toLowerCase();
  return s.includes('tienda_verificadora') || s.includes('verific') || s.includes('punto_recogida') || s.includes('pickup');
}

/** Une fila custody/pickup con transacción anidada para el panel UI. */
export function mergeTxLogisticsForPanel(row) {
  const raw = row?.transaction;
  const t = Array.isArray(raw) ? raw[0] : raw;
  if (!t?.id) return null;
  return {
    ...t,
    partner_outbound_tracking: row.partner_outbound_tracking ?? null,
    partner_outbound_shipped_at: row.partner_outbound_shipped_at ?? null,
  };
}

export const TRANSACTION_LOGISTICS_NESTED = `
  id,
  listing_id,
  buyer_id,
  seller_to_partner_mode,
  buyer_partner_delivery_mode,
  buyer_shipping_address,
  seller_dropoff_tracking,
  seller_dropoff_status,
  seller_dropoff_shipped_at,
  shipping_type,
  verifier_partner_id,
  pickup_partner_id,
  status
`;
